(() => {
  'use strict';

  // Vertical translateY carousel for header promo images.
  // Single slide: no timers. Multi: autoplay + pause offscreen / hidden tab / hover.

  const placeAboveHeader = (root) => {
    const section = root.closest('.shopify-section');
    const header = document.querySelector('header-redesign')?.closest('.shopify-section');
    if (!section || !header || !header.parentNode) return;
    if (header.compareDocumentPosition(section) & Node.DOCUMENT_POSITION_FOLLOWING) {
      header.parentNode.insertBefore(section, header);
    }
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-header-image-carousel]').forEach((root) => {
      placeAboveHeader(root);

      if (root.dataset.hicReady === 'true') return;
      root.dataset.hicReady = 'true';

      const track = root.querySelector('[data-hic-track]');
      const slides = track ? Array.from(track.children) : [];
      if (!track || slides.length < 2) return;

      let index = 0;
      let timer = null;
      const autoplay = Number(root.dataset.autoplay) || 0;
      let inView = true;
      let hovering = false;

      const apply = () => {
        const h = root.clientHeight;
        track.style.transform = `translate3d(0, ${-index * h}px, 0)`;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (slide.tagName === 'A') {
            if (active) slide.removeAttribute('tabindex');
            else slide.setAttribute('tabindex', '-1');
          }
        });
      };

      const go = (next) => {
        index = ((next % slides.length) + slides.length) % slides.length;
        apply();
      };

      const stop = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      const start = () => {
        if (autoplay <= 0 || !inView || hovering || document.hidden) return;
        if (timer) return;
        timer = window.setInterval(() => go(index + 1), autoplay);
      };

      apply();

      root.addEventListener('mouseenter', () => {
        hovering = true;
        stop();
      });
      root.addEventListener('mouseleave', () => {
        hovering = false;
        start();
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else start();
      });

      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(() => apply());
        ro.observe(root);
      } else {
        window.addEventListener('resize', apply, { passive: true });
      }

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          ([entry]) => {
            inView = entry.isIntersecting;
            if (inView) start();
            else stop();
          },
          { root: null, threshold: 0.01 }
        );
        io.observe(root);
      } else {
        start();
      }

      if (autoplay > 0) start();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    target.querySelectorAll('[data-header-image-carousel]').forEach((el) => {
      delete el.dataset.hicReady;
    });
    init(target);
  });
})();
